import { useEffect, type MutableRefObject } from 'react';
import Search from '@arcgis/core/widgets/Search';

type UseMapSearchWidgetArgs = {
  mapView: __esri.MapView | null;
  isActive: boolean;
  searchRef?: MutableRefObject<Search | null>;
  onSelectResult?: (event: __esri.SearchSelectResultEvent) => void;
};

export const useMapSearchWidget = ({
  mapView,
  isActive,
  searchRef,
  onSelectResult,
}: UseMapSearchWidgetArgs) => {
  useEffect(() => {
    if (!isActive || !mapView) return;

    const search = new Search({ view: mapView });
    mapView.ui.add(search, 'top-right');
    if (searchRef) {
      searchRef.current = search;
    }

    const handle = onSelectResult
      ? search.on('select-result', onSelectResult)
      : null;

    return () => {
      handle?.remove();
      search.destroy();
      mapView.ui.remove(search);
      if (searchRef) {
        searchRef.current = null;
      }
    };
  }, [isActive, mapView, onSelectResult, searchRef]);
};
